import { Select } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

function LanguageSelect({ languages = [], ...props }) {
  const options = [
    { value: 'multi', label: 'Multiple languages' },
    ...languages.map((l) => ({
      value: l.language_code,
      label: l.display_name,
    })),
  ];

  return (
    <Select
      showSearch
      options={options}
      filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}

LanguageSelect.propTypes = {
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      language_code: PropTypes.string.isRequired,
      display_name: PropTypes.string.isRequired,
    }),
  ),
};

export default LanguageSelect;
